import { createContext } from 'react';
import type { PublicUser } from '@nfa/types';

interface AuthState {
  user: PublicUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export interface AuthContextValue extends AuthState {
  login: (email: string) => Promise<{ success: boolean; message: string }>;
  verifyToken: (token: string) => Promise<void>;
  logout: () => Promise<void>;
  updateUser: (data: { name?: string }) => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
